<template>
  <!-- D: 포커스시 is-open 클래스 추가 -->
  <!-- D: data-layer-hidden 속성 존재시 단순 검색 케이스로 바뀜 -->

  <!-- PC 영역 -->
  <div
    class="c-search only-pc"
    :class="{ 'is-open': isShowHelpLayer }"
    ref="cSearchEl"
    @focusin="() => (isFocusIn = true)"
  >
    <h2 class="sr-only">검색 영역</h2>
    <form class="search-form" @submit.prevent="search">
      <label class="sr-only">제품검색</label>
      <!-- D: MO에서는 input readonly 추가 필요합니다(레이어팝업 오픈하기 위함) -->
      <input
        type="text"
        title="검색"
        class="search-input"
        autocomplete="off"
        :placeholder="'제품(keyword1)'"
        :value="keyword"
        @input="handleSearchInput"
      />
      <input
        type="text"
        title="검색"
        class="search-input"
        autocomplete="off"
        :placeholder="'제품(keyword2)'"
        :value="keyword2"
        @input="handleSearchInput2"
      />
      <input
        type="text"
        title="검색"
        class="search-input"
        autocomplete="off"
        :placeholder="'제품(keyword3)'"
        :value="keyword3"
        @input="handleSearchInput3"
      />
      <button type="button" class="search-cancel" @click="onRemoveKewordBtn">
        <i class="c-icon icon-large-x"></i>
        <span class="sr-only">검색어 재입력</span>
      </button>
      <button type="submit" class="search-submit">
        <span class="sr-only">검색</span>
      </button>
    </form>

    <!-- search layer -->
    <div class="search-layer" ref="searchLayerEl">
      <div class="search-layer-inner">
        <div v-show="!isShowAutoKeyword" class="c-text-tabs type-small">
          <ul>
            <li class="tab-item">
              <!-- D: is-active, 추가 활성화 -->
              <a
                href="#tab1-1"
                class="tab-anchor"
                :class="{ 'is-active': isShowLatestKeywordTab }"
                role="tab"
                aria-selected
                @click.prevent="() => (isShowLatestKeywordTab = true)"
              >
                최근검색어
              </a>
            </li>
            <li class="tab-item">
              <a
                href="#tab1-2"
                class="tab-anchor"
                :class="{ 'is-active': !isShowLatestKeywordTab }"
                role="tab"
                @click.prevent="() => (isShowLatestKeywordTab = false)"
              >
                인기검색어
              </a>
            </li>
          </ul>
        </div>

        <!-- D: 탭 전체 -->
        <div class="tab-panel-wrap" v-if="!isShowAutoKeyword">
          <!-- D: 탭 내용: 최근 검색어 -->
          <div
            v-if="!isShowAutoKeyword && isShowLatestKeywordTab"
            id="tab1-1"
            class="tab-panel"
            role="tabpanel"
          >
            <h3 class="sr-only">최근 검색어 탭 내용</h3>
            <RecentSearchesCont @select="onLatestKeywordSelect" />
          </div>
          <!-- D: 탭 내용: 인기 검색어 -->
          <div
            v-if="!isShowAutoKeyword && !isShowLatestKeywordTab"
            id="tab1-2"
            class="tab-panel"
            role="tabpanel"
          >
            <h3 class="sr-only">인기 검색어 탭 내용</h3>
            <PopularSearchCont @select="onLatestKeywordSelect" />
          </div>
        </div>

        <!-- D: 입력시 노출, 탭 숨김 -->
        <AutoKeywordList
          v-if="isShowAutoKeyword"
          :shwrd="keyword"
          @select="onLatestKeywordSelect"
        />
      </div>
      <button type="button" class="search-layer-close">
        <i class="c-icon icon-small-white-x"></i>
        <span>닫기</span>
      </button>
    </div>
  </div>
  <!-- // PC 영역 -->

  <!-- 모바일 영역 keyword1 -->
  <div class="mobile-search only-mo">
    <form class="search-form" @submit.prevent="search">
      <div class="mobile-inputs">
        <div class="input-wrapper">
          <input
            type="text"
            id="searchQuery"
            title="검색"
            class="search-input"
            autocomplete="off"
            :placeholder="'제품명/제품코드 keyword1'"
            :value="keyword"
            @input="handleSearchInput"
          />
          <button type="button" class="clear-btn-close" @click="onRemoveKewordBtn1">
            <span class="sr-only">검색어 재입력</span>×
          </button>
        </div>
        <div class="input-wrapper">
          <input
            type="text"
            id="searchQuery"
            title="검색"
            class="search-input"
            autocomplete="off"
            :placeholder="'제품명/제품코드 keyword2'"
            :value="keyword2"
            @input="handleSearchInput2"
          />
          <button type="button" class="clear-btn-close" @click="onRemoveKewordBtn2">
            <span class="sr-only">검색어 재입력</span>×
          </button>
        </div>
        <div class="input-wrapper">
          <input
            type="text"
            id="searchQuery"
            title="검색"
            class="search-input"
            autocomplete="off"
            :placeholder="'제품명/제품코드 keyword3'"
            :value="keyword3"
            @input="handleSearchInput3"
          />
          <button type="button" class="clear-btn-close" @click="onRemoveKewordBtn3">
            <span class="sr-only">검색어 재입력</span>×
          </button>
        </div>
      </div>
      <button type="submit" class="search-btn-mobile">
        <span class="search-btn-mobile-submit"></span>검색하기
      </button>
    </form>
</div>

  
  <!-- // 모바일 영역 -->
  <SearchKeywordMoPop
    v-if="isShowMobileSearchKeywordPop"
    :keyword="keyword"
    @keyword-changed="mobileKeywordChanged"
    @close="() => (isShowMobileSearchKeywordPop = false)"
  />

  <!-- // 모바일 영역 -->
  <SearchKeywordMoPop
    v-if="isShowMobileSearchKeywordPop2"
    :keyword="keyword2"
    @keyword-changed="mobileKeywordChanged2"
    @close="() => (isShowMobileSearchKeywordPop2 = false)"
  />

  <!-- // 모바일 영역 -->
  <SearchKeywordMoPop
    v-if="isShowMobileSearchKeywordPop3"
    :keyword="keyword3"
    @keyword-changed="mobileKeywordChanged3"
    @close="() => (isShowMobileSearchKeywordPop3 = false)"
  />
  
</template>
<script setup>
import {
  ref,
  defineEmits,
  defineModel,
  computed,
  onMounted,
  onBeforeUnmount,
  inject,
  watch,
} from "vue";
import RecentSearchesCont from "@/components/paintpro/prod/recentSearchesCont.vue";
import PopularSearchCont from "@/components/paintpro/prod/popularSearchCont.vue";
import AutoKeywordList from "@/components/paintpro/prod/searchAutoKeywordList.vue";
import SearchKeywordMoPop from "@/components/paintpro/prod/searchKeywordMoPop.vue";
import Utils from "@/js/utils";
import { api } from "@/plugins/api";
//import * as cmUtil from "@/utils/cmUtil.js";
//const { isMobile } = cmUtil.useDeviceType();

const url = inject("url_prefix");
const emits = defineEmits(["keywordChanged"]);

// const isShowHelpLayer = ref(false); // 자동완성, 최근/인기 검색 레이어 표시 여부

const isFocusIn = ref(false);
const keyword = defineModel("keyword", { required: true });
const keyword2 = defineModel("keyword2", { required: true });
const keyword3 = defineModel("keyword3", { required: true });

const isShowLatestKeywordTab = ref(true); // 최근검색어탭 표시여부 true: 최근검색어탭/ false: 인기검색어탭

const cSearchEl = ref(); // 검색필드부분 (top, left, rigth 좌표에 필요)
const searchLayerEl = ref(); // 도우미 확장부분 (bottom 좌표에 필요)

const isShowMobileSearchKeywordPop = ref(false);
const isShowMobileSearchKeywordPop2 = ref(false);
const isShowMobileSearchKeywordPop3 = ref(false);

onMounted(() => {
  window.addEventListener("click", windowClickEvent);
});

onBeforeUnmount(() => {
  window.removeEventListener("click", windowClickEvent);
});

watch(keyword, () => {
  if (Utils.isNotBlank(keyword.value)) isFocusIn.value = true;
});

watch(keyword2, () => {
  if (Utils.isNotBlank(keyword2.value)) isFocusIn.value = true;
});

watch(keyword3, () => {
  if (Utils.isNotBlank(keyword3.value)) isFocusIn.value = true;
});

const search = () => {
  isFocusIn.value = false;

  saveAgencySrchHist();
  emits("keywordChanged", keyword.value.trim(), keyword2.value.trim(), keyword3.value.trim());
};

const isShowAutoKeyword = computed(() => {
  // 자동완성 키워드 표시여부 true: 자동완성 / false: 최근/인기 검색 레이어어
  return Utils.isNotBlank(keyword.value);
});

const isShowHelpLayer = computed(() => {
  return isFocusIn.value;
});

const onRemoveKewordBtn = () => {
  keyword.value = "";
  keyword2.value = "";
  keyword3.value = "";
};

const onRemoveKewordBtn1 = () => {
  keyword.value = "";
};

const onRemoveKewordBtn2 = () => {
  keyword2.value = "";
};

const onRemoveKewordBtn3 = () => {
  keyword3.value = "";
};

const windowClickEvent = (event) => {
  if (
    event.x > cSearchEl.value.getBoundingClientRect().left &&
    event.x < cSearchEl.value.getBoundingClientRect().right &&
    event.y > cSearchEl.value.getBoundingClientRect().top &&
    event.y < searchLayerEl.value.getBoundingClientRect().bottom
  ) {
    isFocusIn.value = true;
  } else {
    isFocusIn.value = false;
  }
};

const saveAgencySrchHist = async () => {

  if (Utils.isBlank(keyword.value) && Utils.isBlank(keyword2.value) && Utils.isBlank(keyword3.value)) {
    return;
  }

  const payload = { shwrd: Utils.isBlank(keyword.value)==true?null:keyword.value, 
                    shwrd2: Utils.isBlank(keyword2.value)==true?null:keyword2.value,
                    shwrd3: Utils.isBlank(keyword3.value)==true?null:keyword3.value
                  };

  const res = await api.post(
    `${url}/agency/search/agency-srch-hist/create`,
    payload
  );

  const { resultCode } = res;
  if (resultCode !== 200) {
    return;
  }
};

const onLatestKeywordSelect = async (selectedKeyword) => {
  await setKeyword(selectedKeyword);
  search();
};

const setKeyword = async (_keyword) => {
  keyword.value = _keyword;
};

const setKeyword2 = async (_keyword) => {
  keyword2.value = _keyword;
};

const setKeyword3 = async (_keyword) => {
  keyword3.value = _keyword;
};

/*const handleMobileKeywordClick = () => {
  if (isMobile.value) {
    isShowMobileSearchKeywordPop.value = true;
  }
};

const handleMobileKeywordClick2 = () => {
  if (isMobile.value) {
    isShowMobileSearchKeywordPop2.value = true;
  }
};

const handleMobileKeywordClick3 = () => {
  if (isMobile.value) {
    isShowMobileSearchKeywordPop3.value = true;
  }
};*/

const mobileKeywordChanged = async (_keyword) => {
  await setKeyword(_keyword);
  search();
};

const mobileKeywordChanged2 = async (_keyword) => {
  await setKeyword2(_keyword);
  search();
};

const mobileKeywordChanged3 = async (_keyword) => {
  await setKeyword3(_keyword);
  search();
};

// 한글 입력 후 마우스 클릭 시 순간적으로 입력값이 없어지고 재 작성되는 현상때문에 setTimeout을 설정함
const handleSearchInput = (event) => {
  setTimeout(() => {
    keyword.value = event.target.value;
  }, 10);
};
const handleSearchInput2 = (event) => {
  setTimeout(() => {
    keyword2.value = event.target.value;
  }, 10);
};
const handleSearchInput3 = (event) => {
  setTimeout(() => {
    keyword3.value = event.target.value;
  }, 10);
};
</script>
